import { render, staticRenderFns } from "./RootLink.vue?vue&type=template&id=92f26b20&scoped=true"
import script from "./RootLink.vue?vue&type=script&lang=js"
export * from "./RootLink.vue?vue&type=script&lang=js"
import style0 from "./RootLink.vue?vue&type=style&index=0&id=92f26b20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92f26b20",
  null
  
)

export default component.exports